import { createSelector } from "@reduxjs/toolkit";
import userSlice from "./userSlice";

export const selectUserSlice = (state) => state[userSlice.name];

export const selectCurrentUser = createSelector(
  selectUserSlice,
  (userSlice) => userSlice.currentUser
);

export const selectUserToken = createSelector(
  selectUserSlice,
  (userSlice) => userSlice.currentToken
);

export const selectLoggedIn = createSelector(
  selectUserToken,
  (userToken) => !!userToken
);

export const selectIsUserApproved = createSelector(
  selectCurrentUser,
  (currentUser) => !!currentUser?.confirmed
);

export const selectIsUserPremium = createSelector(
  selectCurrentUser,
  (currentUser) => !!currentUser?.premiumUser
);